import React from 'react';
import { BuildingType } from 'commons/src/models/commonTypeScript';
import styles from './IAQInsight2Header.module.scss';

export type IAQInsight2HeaderProps = {
    building: BuildingType;
};

const IAQInsight2Header: React.FC<IAQInsight2HeaderProps> = ({ building }) => {
    return (
        <div className={styles.header}>
            <div className={styles.headerContent}>
                <h3 className={styles.title}>{building.name}</h3>
                <p className={styles.address}>{building.address}</p>
            </div>
        </div>
    );
};

export default IAQInsight2Header;
